import * as Sentry from "@sentry/react";
import packageJson from "../../package.json";

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: `${import.meta.env.VITE_SENTRY_DSN}`,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 0.1,
    tracePropagationTargets: ["api.bidscape.com"],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
    release: packageJson.version,
  });
}
